import { API_ROUTES } from "../../../../../system/constants/apiRoutes";
import { REPORT_COLUMNS_KEY, REPORT_DATE_KEY } from "./utils";

export const config = {
  columns: [
    "partner_id",
    "partner_login",
    "country_full",
    "reg_date",
    "deposits",
    "withdraws",
    "multiacc_count",
    "regs",
    "first_deposits",
    "deposits_count",
    "rd",
    "rd_percent",
    "ngr",
    "ggr",
    "royalty",
    "transaction_commission",
    "rs_income",
    "partner_income",
    "assured_income",
  ],
  subtotals: [
    "hits",
    "hosts",
    "regs",
    "withdraws",
    "multiacc_count",
    "rd",
    "deposits_count",
    "deposits",
    "bonus",
    "gamers",
    "full_income",
    "comppoints",
    "ltv",
    "full_profit",
    "first_deposits",
    "qualified_players",
    "landing_hits",
    "landing_hosts",
    "ngr",
    "ggr",
    "royalty",
    "transaction_commission",
    "rs_income",
    "partner_income",
    "assured_income",
  ],
  columnsKey: REPORT_COLUMNS_KEY,
  dateKey: REPORT_DATE_KEY,
  api: API_ROUTES.reports.affiliates_geo_details.path,
  apiKey: API_ROUTES.reports.affiliates_geo_details.key,
  fileName: API_ROUTES.reports.affiliates_geo_details.filename,
};
